import { defineMessages } from 'react-intl';

export const scope = 'app.components.IdleSignOut';

export const messages = defineMessages({
  warningTitle: {
    id: `${scope}.warningTitle`,
    defaultMessage: 'Are you still there?',
  },
  warningBody: {
    id: `${scope}.warningBody`,
    defaultMessage: "You've been inactive for a while. For your security, you'll be signed out in {countdown}.",
  },
  btnStaySignedIn: {
    id: `${scope}.btnStaySignedIn`,
    defaultMessage: 'Stay signed in',
  },
  signedOut: {
    id: `${scope}.signedOut`,
    defaultMessage: 'You were signed out because you were inactive for too long. Sign in again to continue.',
  },
});
